import { ENVS } from 'services/envs';

// common view https://{env}.appybee.nl/book/{side/full/inline}/{slug}?widget_locale={en/nl/de}

export const getWidgetUrl = ({ side, slug, widgetLocale }) => {
    const widgetLocaleQuery = widgetLocale ? `?widget_locale=${widgetLocale}` : '';
    return `${ENVS.appBaseUrl}/book/${side}/${slug}${widgetLocaleQuery}`;
};
